import * as actions from './PlanSelectionNewWhatIfsActions';

const initialState = {};
const plans = {};

const PlanSelectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_PLANS: {
      plans[action.clientId] = {};

      for (let i = 0, l = action.plans.length; i < l; i += 1) {
        plans[action.clientId][action.plans[i].planId] = Object.assign({}, action.plans[i], {
          isSelected: false,
          clientId: action.clientId,
        });
      }

      const selectablePlans = Object.keys(plans[action.clientId]).map(key => ({
        ...plans[action.clientId][key],
      }));

      return Object.assign({}, state, {
        [action.clientId]: {
          ...state[action.clientId],
          plans: selectablePlans,
          allPlans: action.plans,
          selectedPlan: null,
          isInitialized: true,
        },
      });
    }

    case actions.ADD_PLAN: {
      const currentSelected = state[action.clientId].selectedPlan;
      plans[action.clientId][action.plan.planId] = Object.assign({}, action.plan, {
        isSelected: action.selected,
        clientId: action.clientId,
      });
      let selectedPlan;
      let localPlans;
      if (action.selected) {
        selectedPlan = action.plan;
        localPlans = [].concat(state[action.clientId].plans, [currentSelected]);
      } else {
        selectedPlan = currentSelected;
        localPlans = [].concat(state[action.clientId].plans, [action.plan]);
      }

      return Object.assign({}, state, {
        [action.clientId]: {
          ...state[action.clientId],
          plans: localPlans,
          allPlans: [...state[action.clientId].allPlans, action.plan],
          selectedPlan,
        },
      });
    }

    case actions.SET_SELECTED: {
      const selectablePlans = plans[action.clientId];
      let selectedPlan;
      let localPlans;
      if (Object.keys(selectablePlans).indexOf(action.fpId) > -1) {
        // Happy path: plan found, select normally and rebuild plans sent to user
        selectedPlan = Object.assign({}, selectablePlans[action.fpId], { isSelected: true });
        localPlans = Object.keys(selectablePlans).reduce((agg, key) => {
          if (selectablePlans[key].planId !== action.fpId) {
            agg.push(selectablePlans[key]);
          }
          return agg;
        }, []);
      } else {
        // We got a bad fpId back, fall back to selecting the default
        // This should only happen on very slow connections with multiple switches between users
        // before a load is finished
        const { ADV } = window;
        selectedPlan = selectablePlans[ADV.adviser.defaultFPID(action.clientId)];
        localPlans = selectablePlans.filter(plan => plan.planId !== action.fpId);
      }
      return Object.assign({}, state, {
        [action.clientId]: {
          ...state[action.clientId],
          selectedPlan,
          plans: localPlans,
          expanded: false,
        },
      });
    }

    case actions.DELETE_PLAN: {
      let localPlans = [].concat(state[action.clientId].plans);
      let { selectedPlan } = state[action.clientId];
      delete plans[action.clientId][action.planId];
      if (action.planId === selectedPlan.planId) {
        // eslint-disable-next-line
        selectedPlan = localPlans[0];
        localPlans.splice(0, 1);
      } else {
        localPlans = localPlans.filter(plan => plan.planId !== action.planId);
      }

      return Object.assign({}, state, {
        [action.clientId]: {
          ...state[action.clientId],
          plans: localPlans,
          allPlans: state[action.clientId].allPlans.filter(plan => plan.planId !== action.planId),
          selectedPlan,
        },
      });
    }

    case actions.SET_LOADING: {
      return Object.assign({}, state, {
        [action.clientId]: {
          ...state[action.clientId],
          loading: action.loading,
        },
      });
    }

    default:
      return state;
  }
};

export default PlanSelectionReducer;
